import { message } from "antd";
import { Input, Modal, Table } from "antd";
import React, { useState, useEffect } from "react";
import { AlertTag } from "~/components/atom/AlertTag.jsx";
import { SaveButton } from "~/components/buttons/SaveButton.jsx";
import { SluitButton } from "~/components/buttons/SluitButton.jsx";
import {
  FlightBijzonderheden,
  FlightDuur,
  FlightKist,
  FlightMethode,
  FlightRol,
  FlightTagsColumn,
  OpenFlightColumn,
} from "~/components/flight/FlightColumns.jsx";
import PincodeInput from "~/components/form/PincodeInput.jsx";
import { HelpBubble } from "~/components/help/helpBubble.jsx";
import { $t } from "~/i18n.js";
import { api } from "~/lib/api.js";

export const BulkSignFlight = ({
  visible,
  onClose,
  currentUser,
  vlieger,
  vliegerData,
  flights,
  saveFlights,
  saveNotitie,
  saveVliegerData,
}) => {
  const [saving, setSaving] = useState(false);
  const [remark, setRemark] = useState("");
  const [pincode, setPincode] = useState("");

  const unsignedFlights = flights?.filter((flight) => !flight.signed)
  const missingBijzonderheden = unsignedFlights.filter(
    (flight) => flight.bijzonderheden === ""
  );

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  useEffect(
    () =>
      setSelectedRowKeys(
        unsignedFlights
          .filter((f) => f.bijzonderheden !== "")
          .map((u) => u.uuid)
      ),
    []
  );

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleSign = async () => {
    setSaving(true);
    let success = true;
    let newFlights = []
    for (let uuid of selectedRowKeys) {

      // only save remark on last flight
      let flight = unsignedFlights.find((f) => f.uuid === uuid);
      let saveRemark = selectedRowKeys.indexOf(uuid) === selectedRowKeys.length - 1;

      const { data } = await api.post2("flights/sign.json", {
        uuid: uuid,
        id: currentUser.id,
        remark: remark,
        pincode,
        save_as_note: saveRemark,
      });
      if (data) {
        newFlights.push(data);
      } else {
        success = false;
        break;
      }
    }
    saveFlights(newFlights)
    setPincode("");
    setSaving(false);
    if (success) {
      saveNotitie({
        user_id: vlieger.id,
        bericht: remark,
        is_signature: true
      })
      saveVliegerData({
        id: vlieger.id,
        newData: {
          ...vliegerData,
          signed_flights: vliegerData.signed_flights + selectedRowKeys.length,
        }
      })
      onClose();
    } else {
      message.error($t("Er is een fout opgetreden tijdens het ondertekenen"));
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={!saving && onClose}
      footer={[
        <SluitButton key="cancel" onClick={onClose} disabled={saving} />,
        <SaveButton
          key="save"
          onClick={handleSign}
          disabled={selectedRowKeys.length === 0 || !pincode}
          loading={saving}
        />,
      ]}
    >
      <p>
        {$t("Teken in bulk ${count} vluchten af van ${name}", {
          count: selectedRowKeys.length,
          name: vlieger.name,
        })}
      </p>

      <Table
        style={{ margin: "18px 0", overflowX: "auto" }}
        rowSelection={rowSelection}
        rowKey="uuid"
        columns={[
          FlightKist(),
          FlightRol(vlieger),
          FlightMethode(),
          FlightDuur(),
          FlightTagsColumn(vlieger, {
            hidePrive: true,
            hideStatus: true,
            hideBeschrijving: true,
          }),
          FlightBijzonderheden(),
          OpenFlightColumn(),
        ]}
        dataSource={unsignedFlights}
        pagination={false}
      />

      {missingBijzonderheden.length > 0 && (
        <div style={{ margin: "12px 0" }}>
          <p>
            <AlertTag style={{ marginRight: 6 }} />
            {$t("${count} vluchten missen een aantekening", {
              count: missingBijzonderheden.length,
            })}
          </p>
          <p className="small">
            {$t(
              "Vraag de vlieger deze alsnog toe te voegen. Aantekeningen zijn waardevol omdat ze inzicht geven in wat de vlieger heeft geleerd of ervaren tijdens de vlucht"
            )}
            .
          </p>
        </div>
      )}

      <p>
        {$t("Opmerking")}{" "}
        <HelpBubble
          content={$t(
            "Opmerking wordt geplaatst bij de laatste vlucht en bij de gebruiker."
          )}
        />
      </p>
      <Input.TextArea
        disabled={selectedRowKeys.length === 0}
        value={remark}
        placeholder={$t("Eventuele opmerking")}
        onChange={(e) => setRemark(e.target.value)}
      />
      <p>{$t("Pincode")}:</p>
      <PincodeInput
        disabled={selectedRowKeys.length === 0}
        value={pincode}
        onComplete={setPincode}
      />
    </Modal>
  );
};
